<ng-container *ngIf="currentProfile$ | async as currentProfile">
  <ng-container *ngIf="currentProfile.isLoggedIn">
    <h2>Покупатель</h2>

    <sd-dropdown #dropdown class="switch-profile">
      <ng-template #dropdownToggler>
        <sd-dropdown-toggler
          (click)="dropdown.toggle()"
          class="switch-profile-toggler text-b4-m-500 color-black-warm-800"
        >
          <span>
            {{ currentProfile.fullName }}
          </span>
        </sd-dropdown-toggler>
      </ng-template>

      <ng-template #dropdownContent>
        <sd-dropdown-menu (click)="dropdown.close()">
          <sd-dropdown-menu-item
            [isActive]="!currentProfile.isLegal"
            class="switch-profile-menu-item"
            (click)="resetCompany()"
          >
            {{ currentProfile.user.name }}
          </sd-dropdown-menu-item>

          <sd-dropdown-menu-item
            *ngFor="let item of currentProfile.companies"
            [isActive]="currentProfile.isLegal && currentProfile.selectedCompanyUid === item.uid"
            class="switch-profile-menu-item"
            (click)="selectCompany(item.uid)"
          >
            {{ item.name }}
          </sd-dropdown-menu-item>

          <sd-add-company-button size="xs" class="switch-profile-menu-item"></sd-add-company-button>
        </sd-dropdown-menu>
      </ng-template>
    </sd-dropdown>
  </ng-container>
</ng-container>
